<template>
  <div>
    <h2 class="box__title">{{ $t('vokalisSettings.title') }}</h2>
    <p class="margin-bottom-2">
      {{ $t('vokalisSettings.description') }}
    </p>
    <Error :error="error"></Error>
    <div v-if="loading" class="loading"></div>
    <div v-else>
      <p class="margin-bottom-2">
        <strong>{{ $t('vokalisSettings.statusLabel') }}</strong>
        <span
          :class="[
            'vokalis-settings__status',
            hasToken
              ? 'vokalis-settings__status--ok'
              : 'vokalis-settings__status--error',
          ]"
        >
          {{
            hasToken
              ? $t('vokalisSettings.statusConfigured')
              : $t('vokalisSettings.statusNotConfigured')
          }}
        </span>
      </p>
      <div class="control">
        <label class="control__label" for="vokalis-token-input">
          {{ $t('vokalisSettings.newTokenLabel') }}
        </label>
        <input
          id="vokalis-token-input"
          v-model="tokenInput"
          type="password"
          class="input"
          :placeholder="$t('vokalisSettings.newTokenPlaceholder')"
          :disabled="saving"
        />
      </div>
      <div class="actions margin-top-2">
        <Button
          type="primary"
          size="small"
          :loading="saving"
          :disabled="saving || !tokenInput"
          @click="saveToken"
        >
          {{ $t('vokalisSettings.saveButton') }}
        </Button>
        <Button
          type="secondary"
          size="small"
          class="margin-left-2"
          :disabled="saving || !hasToken"
          @click="clearToken"
        >
          {{ $t('vokalisSettings.removeButton') }}
        </Button>
      </div>
      <p class="text-muted margin-top-1">
        {{ $t('vokalisSettings.onlyAdminHint') }}
      </p>
    </div>
  </div>
</template>

<script>
import error from '@baserow/modules/core/mixins/error'
import VokalisSettingsService from '@baserow/modules/core/services/vokalisSettings'

export default {
  name: 'VokalisSettings',
  mixins: [error],
  data() {
    return {
      loading: true,
      saving: false,
      hasToken: false,
      tokenInput: '',
    }
  },
  async mounted() {
    try {
      const { data } = await VokalisSettingsService(this.$client).get()
      this.hasToken = !!data.has_token
    } catch (error) {
      this.handleError(error, 'vokalis_settings')
    } finally {
      this.loading = false
    }
  },
  methods: {
    async saveToken() {
      if (!this.tokenInput) {
        return
      }
      this.saving = true
      this.hideError()
      try {
        const { data } = await VokalisSettingsService(this.$client).update({
          token: this.tokenInput,
        })
        this.hasToken = !!data.has_token
        this.tokenInput = ''
      } catch (error) {
        this.handleError(error, 'vokalis_settings')
      } finally {
        this.saving = false
      }
    },
    async clearToken() {
      this.saving = true
      this.hideError()
      try {
        const { data } = await VokalisSettingsService(this.$client).update({
          token: '',
        })
        this.hasToken = !!data.has_token
      } catch (error) {
        this.handleError(error, 'vokalis_settings')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.vokalis-settings__status {
  display: inline-block;
  margin-left: 4px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.85rem;
}

.vokalis-settings__status--ok {
  background-color: #e6f4ea;
  color: #137333;
}

.vokalis-settings__status--error {
  background-color: #fde8e8;
  color: #b00020;
}
</style>
